import React from 'react';
import { Link } from 'react-router-dom';

export default function Error500() {
  return (
    <div className="min-h-screen bg-gray-50">
    <div className="flex flex-col items-center justify-center p-6 text-center min-h-[50vh]">
      <h2 className="text-2xl font-bold mb-4 text-red-600">500 - Server Error</h2>
      <p className="text-gray-700 mb-6">
        Oops! Something went wrong on our end.
      </p>
      <Link
        to="/"
        className="inline-block bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 transition"
      >
        Return to Home
      </Link>
    </div>
    </div>
  );
}
